/* eslint-disable no-undef */
import { yupResolver } from '@hookform/resolvers/yup'
import React, { useContext, useEffect, useState, useRef, useCallback } from 'react'
import { Controller, FormProvider, useForm } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import NoteIcon from '../../../assets/img/svg/note-icon.svg'
import GetInForm from './getInForm'
import ICallForm from './iCallForm'
import TasksForm from './tasksForm'
import ConsumableForm from './consumableForm'
import { propertySchema } from '../../../util/validationSchema'
import { useDispatch, useSelector } from 'react-redux'
import {
  addProperty,
  editProperty,
  getAllConsumables,
  getAllTasks,
  getCityByCityName,
  getPropertyByID,
  getTooltipIcal
} from '../../../redux/slices/propertySlice'
import { SpinnerContext } from '../../../context/spinnerContext'
import { defultPropertyValues, FREEZE_CLIENT_MSG, IMAGE_MODULE } from '../../../util/constant'
import { Accordion, Button, Form } from 'react-bootstrap'
import CustomModal from '../../../component/customModal'
import ListofTask from '../../../component/Property/listofTask'
import EditProperty from './editproperty'
import DropzoneController from '../../../component/dropzone'
import { acceptExtensions, debounce, objectsAreEqual } from '../../../helper/function'
import EditIcon from '../../../assets/img/svg/edit-icon.svg'
import { useLoadScript, StandaloneSearchBox } from '@react-google-maps/api'
import ListofConsumable from '../../../component/Property/listofConsumable'
import UploadProperty from '../../../component/Property/uploadProperty'
import { errorToast, successToast } from '../../../util/Toast/toast'
import axios from 'axios'

const AddEditProperty = () => {
  const { property_id } = useParams()
  const isEditMode = Boolean(property_id)

  const { user } = useSelector(({ auth }) => auth)
  const { getProperty, allTasks, allConsumables } = useSelector(({ property }) => property)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  // eslint-disable-next-line no-unused-vars
  const { changeLoader } = useContext(SpinnerContext)
  const [showListTaskModal, setShowListTaskModal] = useState(false)
  const toggleListTaskModal = () => setShowListTaskModal(!showListTaskModal)
  const [showListConsumableModal, setShowListConsumableModal] = useState(false)
  const toggleListConsumableModal = () => setShowListConsumableModal(!showListConsumableModal)
  const [showUploadModal, setShowUploadModal] = useState(false)
  const toggleUploadModal = () => setShowUploadModal(!showUploadModal)
  const [isRefresh, setIsRefresh] = useState(true)
  const [activePopover, setActivePopover] = useState(null)
  const [accrdionActiveKey, setAccrdionActiveKey] = useState('schedule')
  const [isAboutToggle, setIsAboutToggle] = useState(false)
  // const [address, setAddress] = useState('')
  const inputRef = useRef(null)
  const updatedPropertyValues = isEditMode
    ? {
        property_name: getProperty?.property_name || '',
        client_id: getProperty?.client?.client_id || '',
        number_of_rooms: getProperty?.number_of_rooms || '0',
        number_of_bathroom: getProperty?.number_of_bathroom || '0',
        square_foot: getProperty?.square_foot || '0',
        other: getProperty?.other || '',
        zipcode: getProperty?.zipcode || '',
        address: getProperty?.address || '',
        state: getProperty?.state || '',
        city: getProperty?.city || '',
        location_lat: getProperty?.location_lat || '',
        location_long: getProperty?.location_long || '',
        get_in: getProperty?.get_in || '',
        get_in_instruction: getProperty?.get_in_instruction || '',
        laundry_code: getProperty?.laundry_code || '',
        storage_area_code: getProperty?.storage_area_code || '',
        propertyICalLink:
          getProperty?.propertyICalLink?.length > 0
            ? getProperty?.propertyICalLink.map((link) => ({
                property_cleaning_icallink_id: link?.property_cleaning_icallink_id,
                ical_label: link?.ical_label,
                ical_link: link?.ical_link
              }))
            : [{ property_cleaning_icallink_id: null, ical_label: '', ical_link: '' }],
        property_image: getProperty?.property_image || [],
        airbnb_listing_id: getProperty?.airbnb_listing_id || '',
        airbnb_bedrooms: getProperty?.airbnb_bedrooms || 0,
        airbnb_bathrooms: getProperty?.airbnb_bathrooms || 0,
        request_laundry: getProperty?.request_laundry || false,
        // cleaning_on: getProperty?.cleaning_on || 'Cleaning on checkout',
        propertyTasks:
          getProperty?.propertyTasks?.length > 0
            ? getProperty?.propertyTasks.map((task) => ({
                property_cleaning_task_id: task?.property_cleaning_task_id,
                task: task?.task
              }))
            : [{ property_cleaning_task_id: null, task: '' }],
        propertyConsumables:
          getProperty?.propertyConsumables?.length > 0
            ? getProperty?.propertyConsumables.map((consumable) => ({
                property_cleaning_consumable_id: consumable?.property_cleaning_consumable_id,
                task: consumable?.task
              }))
            : [{ property_cleaning_consumable_id: null, task: '' }]
      }
    : defultPropertyValues

  // Initialize react-hook-form
  const methods = useForm({
    resolver: yupResolver(propertySchema),
    defaultValues: updatedPropertyValues
  })

  const {
    handleSubmit,
    control,
    register,
    watch,
    setValue,
    reset,
    trigger,
    clearErrors,
    formState: { errors }
  } = methods

  const currentValue = watch()

  const hasChanged = objectsAreEqual(currentValue, updatedPropertyValues) || Object.keys(errors)?.length !== 0

  // Reset the form when the initial data changes (switching between add and edit)
  useEffect(() => {
    if (isEditMode && getProperty) {
      reset(updatedPropertyValues)
    } else {
      reset(defultPropertyValues)
    }
  }, [getProperty, reset, isEditMode])

  useEffect(() => {
    setValue('client_id', user?.client_id)
  }, [user])

  // Load Google Maps script

  const libraries = ['places']

  const { isLoaded } = useLoadScript({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    libraries // Use the static libraries array
  })
  // Handle place changes from Google Places API
  const handlePlacesChanged = (onChange) => {
    const places = inputRef?.current?.getPlaces()

    if (places?.length) {
      const place = places[0] // Get the first place
      const lat = place?.geometry?.location?.lat()
      const lng = place?.geometry?.location?.lng()
      const addressComponents = place?.address_components || []
      let city = watch('city')
      // If city is already selected, validate the address
      if (city) {
        const cityMatch = addressComponents.some((comp) => comp.long_name.toLowerCase() === city.toLowerCase())

        if (cityMatch) {
          updateAddressFields(place, lat, lng, onChange)
        } else {
          console.log('Error...')
        }
      } else {
        // If no city is selected, extract city and state
        extractAndSetLocationData(addressComponents, lat, lng, place, onChange)
      }
    } else {
      console.error('No places found')
      // resetLocationFields()
    }
  }

  const updateAddressFields = (place, lat, lng, onChange) => {
    onChange(place?.formatted_address || '')
    // setAddress(place?.formatted_address)
    setValue('location_lat', lat?.toString() || '')
    setValue('location_long', lng?.toString() || '')
  }

  const extractAndSetLocationData = (addressComponents, lat, lng, place, onChange) => {
    let cityFromPlace = ''
    let state = ''
    let zipcode = ''

    addressComponents.forEach((component) => {
      const types = component.types
      if (types.includes('locality')) {
        cityFromPlace = component.long_name
      }

      if (types.includes('administrative_area_level_1')) {
        state = component.long_name
      }
      if (types.includes('postal_code')) {
        zipcode = component.long_name
      }
    })
    updateAddressFields(place, lat, lng, onChange)
    setValue('city', cityFromPlace)
    setValue('state', state)
    setValue('zipcode', zipcode)
    trigger('city')
    trigger('state')
    trigger('zipcode')
  }

  // Fetch city and state based on zipcode
  const getCityAndStateByZipcode = async (zipcode) => {
    try {
      const response = await axios.get('https://maps.googleapis.com/maps/api/geocode/json', {
        params: {
          address: zipcode,
          key: process.env.REACT_APP_GOOGLE_MAP_API_KEY
        }
      })

      const results = response.data.results

      if (results.length > 0) {
        const addressComponents = results[0].address_components
        const city = addressComponents.find((comp) => comp.types.includes('locality'))?.long_name || ''
        const state = addressComponents.find((comp) => comp.types.includes('administrative_area_level_1'))?.long_name || ''

        //check city found in database
        if (city) {
          changeLoader(true)
          const { payload } = await dispatch(getCityByCityName(city))
          changeLoader(false)

          if (payload?.data?.status_code === 200) {
            setValue('city', city)
            setValue('state', state)
            trigger('city')
            trigger('state')
          } else {
            handleCityNotFound()
            errorToast('City not found!')
          }
        }
      }
    } catch (error) {
      handleCityNotFound()
      console.error('Error fetching city and state', error)
    }
  }

  // Handle cases when city is not found
  const handleCityNotFound = () => {
    setValue('city', '')
    setValue('state', '')
    setValue('address', '')
    trigger('city')
    trigger('state')
  }

  // Debounce function for zipcode input
  const debouncedGetCityAndState = useCallback(debounce(getCityAndStateByZipcode, 1000), [])

  // Handle zipcode changes and trigger debounced API call
  const handleZipcodeChange = (e) => {
    const zipcode = e.target.value
    debouncedGetCityAndState(zipcode)
  }
  const handleInputChange = (e) => {
    // setAddress(e.target.value)
    if (!e.target.value) {
      setValue('city', '')
      setValue('state', '')
      setValue('zipcode', '')
      trigger('city')
      trigger('state')
      trigger('zipcode')
    }
  }

  useEffect(() => {
    const fetchTasksAndConsumables = async () => {
      try {
        // Run both dispatches in parallel using Promise.all
        await Promise.all([dispatch(getAllTasks()), dispatch(getAllConsumables())])
      } catch (error) {
        console.error('Error fetching tasks and consumables:', error)
      }
    }

    fetchTasksAndConsumables()
  }, [])

  const mergeData = (previousData, newData, dataType) => {
    return [
      ...previousData,
      ...newData
        .filter((item) => item.task && !previousData.some((prevItem) => prevItem.task === item.task))
        .map((item) => ({
          [dataType]: item?.[dataType] || null,
          task: item?.task || ''
        }))
    ].filter((item) => item.task !== '')
  }

  const handleGetTasks = () => {
    changeLoader(true)
    dispatch(getAllTasks())
      .then(() => {
        const previousTasks = watch('propertyTasks') || []
        const mergedTasks = mergeData(previousTasks, allTasks, 'property_cleaning_task_id')
        setValue('propertyTasks', mergedTasks.length > 0 ? mergedTasks : [])
      })
      .catch((err) => {
        console.log('err :>> ', err)
      })
      .finally(() => changeLoader(false))
  }

  const handleGetConsumables = () => {
    changeLoader(true)
    dispatch(getAllConsumables())
      .then(() => {
        const previousConsumables = watch('propertyConsumables') || []
        const mergedConsumables = mergeData(previousConsumables, allConsumables, 'property_cleaning_consumable_id')
        setValue('propertyConsumables', mergedConsumables.length > 0 ? mergedConsumables : [])
      })
      .catch((err) => {
        console.log('err :>> ', err)
      })
      .finally(() => changeLoader(false))
  }

  useEffect(() => {
    if (!isRefresh) return
    if (property_id) {
      changeLoader(true)
      dispatch(getPropertyByID(property_id))
        .then(() => {
          changeLoader(false)
          setIsRefresh(false)
        })
        .catch(() => {
          changeLoader(false)
        })
    }
  }, [isRefresh])

  useEffect(() => {
    dispatch(getTooltipIcal())
      .then(() => {})
      .catch((err) => {
        console.log('err :>> ', err)
      })
  }, [])

  const handleUpload = () => {
    const data = watch()
    data?.propertyICalLink?.[0]?.ical_link === '' && delete data?.propertyICalLink
    if (property_id) {
      const payload = {
        data: data,
        property_id: property_id
      }
      dispatch(editProperty(payload))
        .then(() => {
          setShowUploadModal(false)
          changeLoader(false)
        })
        .catch(() => {
          changeLoader(false)
          setShowUploadModal(false)
        })
    }
  }

  const onSubmit = (data) => {
    if (user?.is_freezed_client) {
      errorToast(FREEZE_CLIENT_MSG)
      return
    }
    setIsRefresh(false)

    const _data = {
      ...data,
      property_name: data?.property_name.trim(),
      square_foot: data?.square_foot.toString(),
      propertyICalLink: data?.propertyICalLink?.filter((item) => item.ical_link && item.ical_label),
      propertyTasks: data.propertyTasks?.filter((item) => item.task),
      propertyConsumables: data.propertyConsumables?.filter((item) => item.task)
    }

    changeLoader(true)
    if (property_id) {
      const payload = {
        data: _data,
        property_id: property_id
      }
      setAccrdionActiveKey(null)
      dispatch(editProperty(payload)).then(({ payload }) => {
        if (payload?.status === 200) {
          // navigate('/properties')
          changeLoader(false)
          successToast(payload?.data?.status_message || 'Success!')
          setIsAboutToggle(false)
          setIsRefresh(true)
        } else {
          errorToast(payload?.data?.status_message || 'Something went wrong')
          changeLoader(false)
        }
      })
    } else {
      if (!_data?.location_lat || !_data?.location_long) {
        errorToast('Please Enter proper addreess')
        changeLoader(false)
        return
      }
      dispatch(addProperty(_data)).then(({ payload }) => {
        if (payload?.status === 200) {
          navigate('/properties')
          changeLoader(false)
          successToast(payload?.data?.status_message || 'Success!')
          reset()
        } else {
          errorToast(payload?.data?.status_message || 'Something went wrong')
          changeLoader(false)
        }
      })
    }
  }

  useEffect(() => {
    const errorMapping = {
      about: errors?.number_of_bathroom || errors?.number_of_rooms || errors?.square_foot,
      get_in: errors.get_in || errors.get_in_instruction || errors.laundry_code || errors.storage_area_code,
      ical: errors.propertyICalLink,
      task: errors.propertyTasks,
      consumables: errors.propertyConsumables
    }

    if (errorMapping[accrdionActiveKey]) return

    for (const [key, hasError] of Object.entries(errorMapping)) {
      if (hasError) {
        setAccrdionActiveKey(key)
        break
      }
    }
  }, [errors])

  const onAccordionChange = (key) => {
    setAccrdionActiveKey((prev) => (prev !== key ? key : null))
    setActivePopover(null)
  }

  return (
    <>
      <div className="page-wrapper">
        {/* New Code Start */}
        <div>
          {/* Edit Propety Code Start */}
          {isEditMode && (
            <>
              {' '}
              <div className="heading_header_div heading_with_btn">
                <h4>{getProperty?.property_name}</h4>
                {!user?.is_freezed_client && (
                  <div className="d-flex align-items-center gap-2 edit_btn_div">
                    <img className="img-fluid" src={EditIcon} alt="Icon" />
                    <div className="links_text" onClick={() => toggleUploadModal()}>
                      Edit
                    </div>
                  </div>
                )}
              </div>
              <EditProperty
                getProperty={getProperty}
                property_image={watch('property_image')}
                errors={errors}
                control={control}
                trigger={trigger}
                register={register}
                watch={watch}
                setValue={setValue}
                setIsRefresh={setIsRefresh}
                setIsAboutToggle={setIsAboutToggle}
                isAboutToggle={isAboutToggle}
                onAccordionChange={onAccordionChange}
                accrdionActiveKey={accrdionActiveKey}
              />
            </>
          )}
          {/* Edit Propety Code End */}

          {!isEditMode && <h4 className="common_heading_text">New Property</h4>}
          <div className={!isEditMode && 'card'}>
            <div className={!isEditMode && 'card-body card_body_div'}>
              {!isEditMode && <h5 className="card_small_heading">Add Property Details</h5>}
              <>
                <FormProvider {...methods}>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <>
                      <div className="row">
                        {!isEditMode && (
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>
                                  Number of Rooms<span className="text-danger"> *</span>
                                </label>
                                <Controller
                                  name="number_of_rooms"
                                  control={control}
                                  render={({ field: { value, onChange }, fieldState }) => (
                                    <>
                                      <input
                                        className="form-control"
                                        value={value}
                                        type="number"
                                        placeholder="Enter Number of Rooms"
                                        onChange={(val) => {
                                          onChange(val)
                                        }}
                                      />
                                      <small>{fieldState?.error?.message}</small>
                                    </>
                                  )}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>
                                  Number of Bathrooms<span className="text-danger"> *</span>
                                </label>
                                <Controller
                                  name="number_of_bathroom"
                                  control={control}
                                  render={({ field: { value, onChange }, fieldState }) => (
                                    <>
                                      <input
                                        className="form-control"
                                        value={value}
                                        type="number"
                                        placeholder="Enter Number of Bathrooms"
                                        onChange={(val) => {
                                          onChange(val)
                                        }}
                                      />
                                      <small>{fieldState?.error?.message}</small>
                                    </>
                                  )}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>
                                  Square Feet<span className="text-danger"> *</span>
                                </label>
                                <Controller
                                  name="square_foot"
                                  control={control}
                                  render={({ field: { value, onChange }, fieldState }) => (
                                    <>
                                      <input
                                        className="form-control"
                                        value={value}
                                        type="number"
                                        placeholder="Enter Square Feet"
                                        onChange={(val) => {
                                          onChange(val)
                                        }}
                                      />
                                      <small>{fieldState?.error?.message}</small>
                                    </>
                                  )}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Other</label>
                                <Controller
                                  name="other"
                                  control={control}
                                  render={({ field: { value, onChange }, fieldState }) => (
                                    <>
                                      <input
                                        className="form-control"
                                        value={value}
                                        type="text"
                                        placeholder="Enter Other"
                                        onChange={(val) => {
                                          onChange(val)
                                        }}
                                      />
                                      <small>{fieldState?.error?.message}</small>
                                    </>
                                  )}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label>
                                  Property Name<span className="text-danger"> *</span>
                                </label>
                                <Controller
                                  name="property_name"
                                  control={control}
                                  render={({ field: { value, onChange }, fieldState }) => (
                                    <>
                                      <input
                                        className="form-control"
                                        value={value}
                                        type="text"
                                        placeholder="Enter Property Name"
                                        onChange={(val) => {
                                          onChange(val)
                                        }}
                                      />
                                      <small>{fieldState?.error?.message}</small>
                                    </>
                                  )}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label>
                                  Address<span className="text-danger"> *</span>
                                </label>
                                <Controller
                                  name="address"
                                  control={control}
                                  render={({ field: { onChange, value } }) => (
                                    <>
                                      {isLoaded ? (
                                        <StandaloneSearchBox
                                          onLoad={(ref) => (inputRef.current = ref)}
                                          onPlacesChanged={() => handlePlacesChanged(onChange)}
                                        >
                                          <input
                                            className="form-control"
                                            type="text"
                                            value={value}
                                            onChange={(e) => {
                                              handleInputChange(e) // Update address state
                                              onChange(e.target.value) // Update form field value
                                            }}
                                            placeholder="Enter Address"
                                          />
                                        </StandaloneSearchBox>
                                      ) : null}
                                    </>
                                  )}
                                />

                                <small>{errors?.address?.message}</small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>
                                  Zipcode<span className="text-danger"> *</span>
                                </label>
                                <Controller
                                  name="zipcode"
                                  control={control}
                                  render={({ field: { value, onChange }, fieldState }) => (
                                    <>
                                      <input
                                        className="form-control"
                                        value={value}
                                        type="text"
                                        placeholder="Enter Zipcode"
                                        onChange={(val) => {
                                          onChange(val)
                                          handleZipcodeChange(val)
                                          trigger('zipcode')
                                        }}
                                      />
                                      <small>{fieldState?.error?.message}</small>
                                    </>
                                  )}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>
                                  City<span className="text-danger"> *</span>
                                </label>
                                <Controller
                                  name="city"
                                  control={control}
                                  render={({ field: { value, onChange }, fieldState }) => (
                                    <>
                                      <input
                                        className="form-control"
                                        value={value}
                                        readOnly
                                        type="text"
                                        placeholder="Enter City"
                                        onChange={(val) => {
                                          onChange(val)
                                          trigger('city')
                                        }}
                                      />
                                      <small>{fieldState?.error?.message}</small>
                                    </>
                                  )}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>
                                  State<span className="text-danger"> *</span>
                                </label>
                                <Controller
                                  name="state"
                                  control={control}
                                  render={({ field: { value, onChange }, fieldState }) => (
                                    <>
                                      <input
                                        className="form-control"
                                        value={value}
                                        readOnly
                                        type="text"
                                        placeholder="Enter State"
                                        onChange={(val) => {
                                          onChange(val)
                                          trigger('state')
                                        }}
                                      />
                                      <small>{fieldState?.error?.message}</small>
                                    </>
                                  )}
                                />
                              </div>
                            </div>

                            <div className="col-md-12">
                              <div className="form-group">
                                <label>Upload Your Property Photos</label>
                                <DropzoneController
                                  name="property_image"
                                  maxFiles={10}
                                  acceptExtensions={acceptExtensions}
                                  control={control}
                                  files={watch('property_image')}
                                  module={IMAGE_MODULE.PROPERTIES}
                                  isAddMode={true}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                        {/* Accordion Design Start */}
                        <div className="accordion_main_div">
                          <Accordion activeKey={accrdionActiveKey}>
                            <Accordion.Item eventKey="get_in">
                              <Accordion.Header onClick={() => onAccordionChange('get_in')}>Get In</Accordion.Header>
                              <Accordion.Body>
                                <GetInForm
                                  control={control}
                                  errors={errors}
                                  register={register}
                                  watch={watch}
                                  setValue={setValue}
                                  isEditMode={isEditMode}
                                />
                              </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="ical">
                              <Accordion.Header onClick={() => onAccordionChange('ical')}>ICAL</Accordion.Header>
                              <Accordion.Body>
                                <p className="accordion_sec_title">Add one or many ICal links</p>
                                <ICallForm
                                  control={control}
                                  errors={errors.ICallForm}
                                  register={register}
                                  watch={watch}
                                  setValue={setValue}
                                  activePopover={activePopover}
                                  setActivePopover={setActivePopover}
                                />
                              </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="task">
                              <Accordion.Header onClick={() => onAccordionChange('task')}>Task</Accordion.Header>
                              <Accordion.Body>
                                <div className="head_checklist">
                                  <h6 className="acc_title">
                                    We have a{' '}
                                    <Button className="hightlight_box" onClick={() => toggleListTaskModal()}>
                                      <img src={NoteIcon} alt="upload" width={16} /> List of Task
                                    </Button>{' '}
                                    for your cleaner.
                                  </h6>
                                  <Button
                                    className="Checklist_btn white_icon_with_btn_svg d-flex align-items-center gap-1"
                                    onClick={() => {
                                      handleGetTasks()
                                      clearErrors('propertyTasks')
                                    }}
                                  >
                                    Import Checklist
                                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path
                                        d="M11.2519 4.84253L7.79683 8.10253C7.38878 8.48753 6.72108 8.48753 6.31303 8.10253L2.85791 4.84253"
                                        stroke="white"
                                        strokeWidth="1.68195"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </Button>
                                </div>
                                <p className="accordion_sec_title mb-3">
                                  Add your own checklist or special request if you want. If our list is enough, you can skip this part and click
                                  ‘save’.
                                </p>
                                <TasksForm />
                              </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="consumables">
                              <Accordion.Header onClick={() => onAccordionChange('consumables')}>Consumables</Accordion.Header>
                              <Accordion.Body>
                                <div className="head_checklist">
                                  <h6 className="acc_title">
                                    {' '}
                                    Missing any consumables that you provide to your guest from our{' '}
                                    <Button className="hightlight_box" onClick={() => toggleListConsumableModal()}>
                                      <img src={NoteIcon} alt="upload" width={16} /> Default List
                                    </Button>{' '}
                                    ? Just add them here to help us track the inventory. Again, this is optional. You can skip it and click ‘save’.
                                  </h6>
                                  <Button
                                    className="Checklist_btn white_icon_with_btn_svg d-flex align-items-center gap-1"
                                    onClick={() => {
                                      handleGetConsumables()
                                      clearErrors('propertyConsumables')
                                    }}
                                  >
                                    Import Checklist
                                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path
                                        d="M11.2519 4.84253L7.79683 8.10253C7.38878 8.48753 6.72108 8.48753 6.31303 8.10253L2.85791 4.84253"
                                        stroke="white"
                                        strokeWidth="1.68195"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </Button>
                                </div>
                                <p className="accordion_sec_title mb-3">
                                  Add your own checklist or special request if you want. If our list is enough, you can skip this part and click
                                  ‘save’.
                                </p>
                                <ConsumableForm />
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        </div>
                        {/* Accordion Design End */}
                      </div>
                      {!isEditMode && (
                        <div className="mt-3">
                          <Controller
                            name="request_laundry"
                            control={control}
                            // checked={true}
                            defaultValue={false}
                            render={({ field }) => (
                              <>
                                <Form.Check
                                  type="switch"
                                  id="custom-switch"
                                  label={`I want the cleaner to do the laundry`}
                                  {...field}
                                  checked={field.value} // ensures checked state is bound to value
                                  // onChange={() => {
                                  //   handleCheckboxChange(option)
                                  //   trigger('request_laundry')
                                  // }}
                                />
                                {/* <small>{fieldState?.error?.message}</small> */}
                              </>
                            )}
                          />
                        </div>
                      )}
                      <div className="text-center mt-4">
                        <button className="btn btn-lg btn-block w-80 btn-primary" type="submit" disabled={hasChanged}>
                          Submit
                        </button>
                      </div>
                      {showUploadModal && (
                        <CustomModal isOpen={showUploadModal} toggle={toggleUploadModal} isTitle={false}>
                          <div className="p-3">
                            <UploadProperty />
                            <div className="multi_btn_div">
                              <button
                                type="button"
                                className="btn common-outline-btn w-100"
                                onClick={() => {
                                  setShowUploadModal(false)
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                type="submit"
                                className="btn btn-primary w-100"
                                onClick={() => {
                                  handleUpload()
                                }}
                              >
                                Upload
                              </button>
                            </div>
                          </div>
                        </CustomModal>
                      )}
                    </>
                  </form>
                </FormProvider>
              </>
            </div>
          </div>
        </div>
        {/* New Code End */}
      </div>
      {showListTaskModal && (
        <CustomModal isOpen={showListTaskModal} toggle={toggleListTaskModal} title={`List of Tasks`} size="md">
          <ListofTask />
        </CustomModal>
      )}
      {showListConsumableModal && (
        <CustomModal isOpen={showListConsumableModal} toggle={toggleListConsumableModal} title={`List of Consumables`} size="md">
          <ListofConsumable />
        </CustomModal>
      )}
      {/* {showUploadModal && (
        <CustomModal isOpen={showUploadModal} toggle={toggleUploadModal} isTitle={false}>
          <div className="p-3">
            <UploadProperty />
            <div className="multi_btn_div">
              <button type="button" className="btn common-outline-btn w-100" onClick={() => setShowUploadModal(false)}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary w-100" onClick={() => {}}>
                Upload
              </button>
            </div>
          </div>
        </CustomModal>
      )} */}
    </>
  )
}

export default AddEditProperty
